import { render, staticRenderFns } from "./LoyaltySummary.vue?vue&type=template&id=016a815a&scoped=true&"
import script from "./LoyaltySummary.vue?vue&type=script&lang=js&"
export * from "./LoyaltySummary.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltySummary.vue?vue&type=style&index=0&id=016a815a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a815a",
  null
  
)

export default component.exports